<template>
  <v-tooltip v-if="errors.length" bottom>
    <template v-slot:activator="{ on }">
      <v-icon color="error" v-on="on">error</v-icon>
    </template>
    <div flat >
      <div class="d-flex flex-column pa-2" v-if="enviroment == 'development' || isSuperUser">
        <span class="a-title mb-2 white--text">Errors was found:</span>
        <span
          class="a-text mb-1"
          v-for="(error, i) in filteredErrors"
          :key="error + i"
          >{{ error }}</span
        >
      </div>
      <span v-else class="a-title mb-2 white--text"
        >Errors was found, reload the page.</span
      >
    </div>
  </v-tooltip>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Errors",
  props: {
    errors: Array,
  },
  data() {
    return {
      enviroment: process.env.NODE_ENV,
    };
  },
  computed: {
    ...mapGetters(["isSuperUser"]),
    filteredErrors() {
      return this.errors.filter((e, i) => this.errors.indexOf(e) === i);
    },
  },
};
</script>

<style scoped>
</style>